module.exports = __webpack_public_path__ + "img/part2-icon.5b6c20a0.png";